import { HexColor } from "../util/typeAliases";

export class RatingColors {
    public urgent: HexColor = "#ff0000";
    public hot: HexColor = "#ff9200";
    public warm: HexColor = "#6ade7a";
    public cold: HexColor = "#00c4ff";
}
